<template>
    <div class="task-status">
      <span v-if="task_status == 2" class="text-success"><i class="fa-solid fa-check mr-1"></i> Completed</span>
      <span v-else-if="task_status == 1" class="text-warning"><i class="fa-solid fa-clock mr-1"></i>Pending</span>
      <span v-else-if="task_status == 0" class="text-secondary"><i class="fa-solid fa-moon mr-1"></i>Inactive</span>
      <span v-else-if="task_status == 3" class="text-warning"><i class="fa-solid fa-pause mr-1"></i>On-Hold</span>
    </div>
</template>
<script>
    // task status
    // *  0 - task inactive
    // *  1 - task pending
    // *  2 - task completed
    // *  3 - task on-hold
    export default {
        props: ['task_status']
    }
</script>
